import React, { useEffect, useState } from 'react'
import "./Header.css"
import { FaBars } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { RxCross2 } from "react-icons/rx";
import logo from "../Assets/logo.png"

export default function Header() {
  const [mobilenavbar, setMobilenavbar] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
    <header id="header" className={scrolling ? "header-scrolled fixed-top " :"fixed-top "}>
    <div className="container d-flex align-items-center">
      <h1 className="logo me-auto"><Link to={"#home"}><img src={logo} alt="" className='img-fluid' /></Link></h1>
      <nav id="navbar" className={mobilenavbar === false ? "navbar" : "navbar-mobile"}>
        <ul>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link scrollto active" to="#home" >Home</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link scrollto" to="#about">About</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link scrollto" to="#services">Services</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link   scrollto" to="#portfolio">Portfolio</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link scrollto" to="#faq">Faq</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="nav-link contact-link scrollto" to="#contact">Contact</Link></li>
          <li onClick={()=>setMobilenavbar(false)}><Link className="getstarted contact-link scrollto" to="#home">Get Started</Link></li>
        </ul>
        {
          mobilenavbar === false ?  <FaBars className='mobile-nav-toggle' onClick={()=>setMobilenavbar(true)}/> : <RxCross2 className='mobile-nav-toggle' onClick={()=>setMobilenavbar(false)}/>
        }
      </nav>
    </div>
  </header>
  </>
  )
}
